import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useParams, useNavigate } from "react-router-dom";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { toast } from "react-toastify";
import { userService } from "../../services/userService";

export default function ResetPassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { idAndToken } = useParams();
  const navigate = useNavigate();
  const [entityId, token] = idAndToken ? idAndToken.split("&&&") : ["", ""];

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      toast.error("Please fill in both fields");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setLoading(true);

      await userService.resetPasswordByToken({
        newPassword: password,
        entityId,
        token,
      });

      toast.success("✅ Password reset successfully!");
      navigate("/login");
    } catch (error) {
      console.error("Password reset failed:", error);
      toast.error("❌ Password reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-teal-500 relative">
      <div className="absolute w-72 h-72 bg-white opacity-10 rounded-full top-10 left-10"></div>
      <div className="absolute w-96 h-96 bg-white opacity-10 rounded-full bottom-10 right-10"></div>
      <div className="absolute w-96 h-96 bg-white opacity-10 rounded-full top-12 center"></div>

      <div className="text-center text-white mb-6 z-10">
        <h1 className="text-4xl font-bold">Reset Your Password</h1>
        <p className="text-md">Enter and confirm your new password below.</p>
      </div>

      <div className="bg-white p-8 rounded-2xl shadow-lg w-96 z-10">
        <h2 className="text-xl font-semibold text-center mb-4">
          Reset Password
        </h2>
        <form onSubmit={handleResetPassword}>
          <div className="mb-4">
            <label className="block text-sm font-medium">New Password</label>
            <div className="relative mt-1">
              <Input
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium">
              Confirm Password
            </label>
            <div className="relative mt-1">
              <Input
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                disabled={loading}
              />
            </div>
          </div>

          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? "Resetting..." : "Reset Password"}
          </Button>
        </form>
      </div>
    </div>
  );
}
